import React from "react";

function Herosection({ title }) {
  return (
    <div id="herosection-Wrapper" className="text-center ">
      <h2 className="fw-bold" data-aos="fade-down">
        {title}
      </h2>
    </div>
  );
}

export default Herosection;
